/* CUSTOM-KIRN: header — fade in background only after 80px scroll. */
(() => {
  const THRESHOLD = 80;
  const wrapper = document.querySelector('.header-wrapper');
  if (!wrapper) return;

  let ticking = false;
  const update = () => {
    const past = window.scrollY > THRESHOLD;
    wrapper.classList.toggle('kirn-header--scrolled', past);
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
